function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useInfiniteQuery } from '@tanstack/react-query';
import { getApiCourses, GetApiCoursesType } from '@edusense/course-client';
import { useAuth } from '@edusense/shared-auth-core';
import { getLocale } from '@paraglide/runtime';
var COURSE_QUERY_KEY = 'courses';
var toCourse = function(item) {
    var _extras_mediaFiles;
    var instructor = item.instructor;
    var price = item.price ? {
        amount: item.price.amount.toString(),
        currency: item.price.currency
    } : undefined;
    var extras = item;
    var _extras_progressRate;
    var progressRate = (_extras_progressRate = extras.progressRate) !== null && _extras_progressRate !== void 0 ? _extras_progressRate : null;
    var thumbnailUrl = typeof item.thumbnailUrl === 'string' ? item.thumbnailUrl : undefined;
    var _extras_mediaFiles_map;
    var mediaFiles = (_extras_mediaFiles_map = (_extras_mediaFiles = extras.mediaFiles) === null || _extras_mediaFiles === void 0 ? void 0 : _extras_mediaFiles.map(function(url) {
        return typeof url === 'string' ? {
            fileUrl: url
        } : url;
    })) !== null && _extras_mediaFiles_map !== void 0 ? _extras_mediaFiles_map : thumbnailUrl ? [
        {
            fileUrl: thumbnailUrl
        }
    ] : undefined;
    var _item_description, _extras_averageRating, _extras_level, _ref, _extras_tags, _extras_createdAt, _extras_availableLanguages, _extras_defaultLanguage;
    return {
        id: String(item.id),
        title: item.title,
        description: (_item_description = item.description) !== null && _item_description !== void 0 ? _item_description : undefined,
        instructor: instructor ? {
            id: String(instructor.id),
            username: instructor.username,
            displayName: instructor.displayName,
            profileImageUrl: instructor.profileImageUrl
        } : undefined,
        averageRating: (_extras_averageRating = extras.averageRating) !== null && _extras_averageRating !== void 0 ? _extras_averageRating : undefined,
        enrollmentCount: extras.enrollmentCount != null ? String(extras.enrollmentCount) : undefined,
        reviewCount: extras.reviewCount != null ? String(extras.reviewCount) : undefined,
        progressRate: progressRate !== null && progressRate !== void 0 ? progressRate : undefined,
        isCompleted: progressRate != null ? progressRate >= 1 : false,
        isFree: !item.price || item.price.amount === 0,
        price: price,
        level: (_ref = (_extras_level = extras.level) !== null && _extras_level !== void 0 ? _extras_level : item.level) !== null && _ref !== void 0 ? _ref : undefined,
        tags: (_extras_tags = extras.tags) !== null && _extras_tags !== void 0 ? _extras_tags : undefined,
        createdAt: (_extras_createdAt = extras.createdAt) !== null && _extras_createdAt !== void 0 ? _extras_createdAt : item.createdAt,
        mediaFiles: mediaFiles,
        availableLanguages: (_extras_availableLanguages = extras.availableLanguages) !== null && _extras_availableLanguages !== void 0 ? _extras_availableLanguages : undefined,
        defaultLanguage: (_extras_defaultLanguage = extras.defaultLanguage) !== null && _extras_defaultLanguage !== void 0 ? _extras_defaultLanguage : undefined
    };
};
export function useCourseData() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = _ref.type, userId = _ref.userId, status = _ref.status, searchQuery = _ref.searchQuery, _ref_pageSize = _ref.pageSize, pageSize = _ref_pageSize === void 0 ? 10 : _ref_pageSize, _ref_enabled = _ref.enabled, enabled = _ref_enabled === void 0 ? true : _ref_enabled;
    var _queryResult_data, _queryResult_data1;
    var isAuthenticated = useAuth().isAuthenticated;
    var currentLanguage = getLocale().split('-')[0];
    var resolvedType = type !== null && type !== void 0 ? type : GetApiCoursesType.FORYOU;
    var queryResult = useInfiniteQuery({
        queryKey: [
            COURSE_QUERY_KEY,
            resolvedType,
            userId !== null && userId !== void 0 ? userId : 'self',
            status !== null && status !== void 0 ? status : 'ALL',
            searchQuery !== null && searchQuery !== void 0 ? searchQuery : 'NONE',
            currentLanguage,
            pageSize
        ],
        enabled: enabled,
        initialPageParam: 0,
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var _param_pageParam, pageParam, params, requestParams, response, _response_content, content, _response_number, currentPage, _response_last, isLastPage;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _param_pageParam = param.pageParam, pageParam = _param_pageParam === void 0 ? 0 : _param_pageParam;
                            params = {
                                type: resolvedType,
                                page: pageParam,
                                size: pageSize
                            };
                            requestParams = _object_spread({}, params);
                            if ((resolvedType === GetApiCoursesType.ENROLLED || resolvedType === GetApiCoursesType.USER || resolvedType === GetApiCoursesType.MY_PUBLISHED) && userId) {
                                requestParams.userId = userId;
                            }
                            if (status && resolvedType === GetApiCoursesType.ENROLLED) {
                                requestParams.status = status;
                            }
                            if (searchQuery) {
                                requestParams.searchTerm = searchQuery;
                            }
                            if (resolvedType === GetApiCoursesType.MY_PUBLISHED && !isAuthenticated) {
                                return [
                                    2,
                                    {
                                        courses: [],
                                        pageInfo: {
                                            currentPage: pageParam,
                                            isLastPage: true
                                        }
                                    }
                                ];
                            }
                            return [
                                4,
                                getApiCourses(requestParams)
                            ];
                        case 1:
                            response = _state.sent();
                            content = (_response_content = response === null || response === void 0 ? void 0 : response.content) !== null && _response_content !== void 0 ? _response_content : [];
                            currentPage = (_response_number = response === null || response === void 0 ? void 0 : response.number) !== null && _response_number !== void 0 ? _response_number : pageParam;
                            isLastPage = (_response_last = response === null || response === void 0 ? void 0 : response.last) !== null && _response_last !== void 0 ? _response_last : (response === null || response === void 0 ? void 0 : response.totalPages) != null ? currentPage + 1 >= response.totalPages : content.length === 0;
                            return [
                                2,
                                {
                                    courses: content.map(toCourse),
                                    pageInfo: {
                                        currentPage: currentPage,
                                        isLastPage: isLastPage
                                    }
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        getNextPageParam: function(lastPage) {
            if (lastPage.pageInfo.isLastPage) {
                return undefined;
            }
            return lastPage.pageInfo.currentPage + 1;
        },
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000
    });
    var _queryResult_data_pages_flatMap;
    var data = (_queryResult_data_pages_flatMap = (_queryResult_data = queryResult.data) === null || _queryResult_data === void 0 ? void 0 : _queryResult_data.pages.flatMap(function(page) {
        return page.courses;
    })) !== null && _queryResult_data_pages_flatMap !== void 0 ? _queryResult_data_pages_flatMap : [];
    var _queryResult_hasNextPage, _queryResult_hasNextPage1, _queryResult_data_pages_length;
    return {
        data: data,
        isLoading: queryResult.isLoading,
        error: queryResult.error,
        fetchNextPage: queryResult.fetchNextPage,
        hasNextPage: (_queryResult_hasNextPage = queryResult.hasNextPage) !== null && _queryResult_hasNextPage !== void 0 ? _queryResult_hasNextPage : false,
        isFetchingNextPage: queryResult.isFetchingNextPage,
        refresh: queryResult.refetch,
        observerRef: null,
        pagination: {
            last: !((_queryResult_hasNextPage1 = queryResult.hasNextPage) !== null && _queryResult_hasNextPage1 !== void 0 ? _queryResult_hasNextPage1 : false),
            totalPages: (_queryResult_data_pages_length = (_queryResult_data1 = queryResult.data) === null || _queryResult_data1 === void 0 ? void 0 : _queryResult_data1.pages.length) !== null && _queryResult_data_pages_length !== void 0 ? _queryResult_data_pages_length : 0,
            totalElements: data.length
        }
    };
}
